import React from "react";
import { Link } from "react-router-dom";
import TrustLayout, { H2 } from "./TrustLayout";

export default function Terms() {
  return (
    <TrustLayout
      meta={{
        path: "/terms",
        kicker: "The rules",
        title: "Terms of Use | Centennial",
        description:
          "Terms of use for My Centennial Plan: free educational tools, no financial advice, acceptable use, paid professional features, and limitation of liability.",
        h1: "Terms of Use",
        reviewed: "June 2026",
      }}
    >
      <H2>Acceptance</H2>
      <p>
        By using mycentennialplan.com you agree to these terms. If you do not agree, please do
        not use the site.
      </p>

      <H2>Educational use only</H2>
      <p>
        All tools and content are educational. Nothing on this site is financial, investment,
        tax, legal, or medical advice, and nothing creates an advisor-client relationship. See
        the <Link className="text-[#2B5339] underline" to="/disclaimer">full disclaimer</Link>.
      </p>

      <H2>Free tools</H2>
      <p>
        The calculator, guides, checklists, workbook, and medication organizer are free for
        personal use. Educators may use them in classrooms. The embeddable calculator may be
        placed on third-party sites via the provided snippet.
      </p>

      <H2>Paid features</H2>
      <p>
        Optional paid features (AI critique unlock, advisor embeds, listings, sponsorships,
        medication-tool unlocks) are one-time or recurring purchases processed by Stripe. Access
        tokens are time-limited as described at purchase. Fees are non-refundable except where
        required by law or at our discretion.
      </p>

      <H2>Acceptable use</H2>
      <p>
        Do not abuse, overload, scrape at disruptive volume, or attempt to compromise the
        service. Community submissions (scenarios, book listings) must be lawful and relevant;
        we may remove any submission at our discretion.
      </p>

      <H2>No warranty & limitation of liability</H2>
      <p>
        The service is provided "as is" without warranties of any kind. Projections are
        estimates, not guarantees. To the maximum extent permitted by law, My Centennial Plan and
        its founder are not liable for any damages arising from use of the site, including
        decisions made based on its output.
      </p>

      <H2>Changes</H2>
      <p>
        We may update these terms; the "last reviewed" date above reflects the current version.
        Continued use after changes constitutes acceptance.
      </p>
    </TrustLayout>
  );
}
